import ReactDOM from 'react-dom'

const style = `
  body {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @keyframes dot-blink {
    0% { opacity: 0; }
    50% { opacity: 1; }
    100% { opacity: 0; }
  }  

  @keyframes dot-blink {
    0% { opacity: 0; }
    50% { opacity: 1; }
    100% { opacity: 0; }
  }

  .animation-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .header {
    font-family: 'ProximaSoft-Regular';
    font-weight: 200;
    font-style: normal;
    color: #394f5a;
  }

  .animated-dot {
    margin: 0 .6rem;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    animation: dot-blink 1.5s ease-in-out infinite;
    border: 1px solid transparent;
    background: #9A9A9A;
  }

  .delay-1 {
    animation-delay: 0.2s;
  }

  .delay-2 {
    animation-delay: 0.4s;
  }

  .delay-3 {
    animation-delay: 0.6s;
  }`

const redirectWindow = () => {
  return (
    <div>
      <h1 className="header">Redirecting...</h1>
      <div className="animation-container">
        <div className="delay-1 animated-dot" />
        <div className="delay-2 animated-dot" />
        <div className="delay-3 animated-dot" />
      </div>
    </div>
  )
}

const createStylesheet = (window) => {
  const stylesheet = window.document.createElement('link')
  stylesheet.rel = 'stylesheet'
  stylesheet.href = `data:text/css,${style}`
  return stylesheet
}

export const renderRedirectViewInWindow = (window) => {
  const container = window.document.createElement('div')
  const head = window.document.getElementsByTagName('head')[0]
  const stylesheet = createStylesheet(window)
  head.appendChild(stylesheet)
  window.document.body.appendChild(container)
  ReactDOM.render(redirectWindow(), container)
}




// WEBPACK FOOTER //
// ./src/scripts/components/Integration/ExternalIntegrationInstallModal/redirectWindow.js